import React, { useRef } from "react";
import CssTransition from "../../../component/layout/css-transition";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { sanitizeInput } from "../../../utils";

const schema = yup.object({
  token_name: yup
    .string()
    .required("Token name is required.")
    // .matches(/^[^\s]+(?:$|.*[^\s]+$)/, "Blank space not allowed in token name.")
    .max(100, "Token name must be equal or less than 100 characters."),
});

export default function AddAccessTokenModal({
  modalId,
  modalOpen,
  setModalOpen,
  _handleSubmit,
}) {
  const modalContent = useRef(null);
  const { company, id } = useSelector((state) => state.auth);
  const { control, handleSubmit, reset, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    const payload = {
      token_name: data.token_name.trim()
    };
    _handleSubmit(payload);
    setModalOpen(false);
    reset({
      token_name: "",
    });
  };
  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id={modalId}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white w-full overflow-auto max-w-lg max-h-full rounded-2xl shadow-lg flex flex-col"
        >
          <div class="py-8 px-6 ">
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">
              Create Access Token
            </h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="token_name"
                control={control}
                defaultValue=""
                render={({ field: { ref, onChange, ...field }, formState }) => (
                  <div className="mb-5">
                    <label
                      className="block text-sm font-medium mb-1"
                      htmlFor="name"
                    >
                      Token Name<span className="text-rose-500">*</span>
                    </label>
                    <input
                      ref={(ref) => {
                        if (ref) ref.focus();
                      }}
                      {...field}
                      onChange={(e)=> {
                        const value = sanitizeInput(e.target.value);
                        setValue("token_name", value)
                      }}
                      className="form-input w-full"
                      placeholder="Enter Token Name"
                      type="text"
                    />
                    {formState.errors?.token_name && (
                      <div className="text-xs text-rose-600 pt-1 pl-1">
                        {formState.errors?.token_name?.message}
                      </div>
                    )}
                  </div>
                )}
              />

              <div class="flex justify-end space-x-2 w-full">
                <button
                  type="button"
                  className="btn bg-slate-100 border-slate-200 hover:border-slate-300 text-slate-600 w-full"
                  onClick={() => {
                    setModalOpen(false);
                    reset({
                      token_name: "",
                    });
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white w-full"
                  type="Submit"
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
}
